import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "./App.css";
import { AuthProvider } from "./lib/AuthContext";
import { Toaster } from "sonner";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import PremiumGate from "./components/PremiumGate";
import InstallBanner from "./components/InstallBanner";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import UploadResume from "./pages/UploadResume";
import FindJobs from "./pages/FindJobs";
import ATSReview from "./pages/ATSReview";
import ResumeVersions from "./pages/ResumeVersions";
import TailorResume from "./pages/TailorResume";
import CreateCV from "./pages/CreateCV";
import CvBuilder from "./pages/CvBuilder";
import ResumeTemplates from "./pages/ResumeTemplates";
import CoverLetter from "./pages/CoverLetter";
import InterviewPractice from "./pages/InterviewPractice";
import ApplicationTracker from "./pages/ApplicationTracker";
import CareerProfile from "./pages/CareerProfile";
import JobAgent from "./pages/JobAgent";
import Pipeline from "./pages/Pipeline";
import Pricing from "./pages/Pricing";
import Settings from "./pages/Settings";
import AuthCallback from "./pages/AuthCallback";
import Admin from "./pages/Admin";
import Tutorial from "./pages/Tutorial";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";

function Protected({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function AppRouter() {
  const location = useLocation();
  // CRITICAL: handle session_id during render to avoid race conditions
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/privacy-policy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/terms-of-use" element={<Terms />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/contact-support" element={<Contact />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/upload" element={<Protected><UploadResume /></Protected>} />
      <Route path="/jobs" element={<Protected><FindJobs /></Protected>} />
      <Route path="/ats" element={<Protected><ATSReview /></Protected>} />
      <Route path="/versions" element={<Protected><PremiumGate feature="Resume Versions"><ResumeVersions /></PremiumGate></Protected>} />
      <Route path="/tailor" element={<Protected><PremiumGate feature="Tailor Resume"><TailorResume /></PremiumGate></Protected>} />
      <Route path="/create-cv" element={<Protected><CvBuilder /></Protected>} />
      <Route path="/cv-builder" element={<Protected><CvBuilder /></Protected>} />
      <Route path="/cv-builder/:cvId" element={<Protected><CvBuilder /></Protected>} />
      <Route path="/resume-templates" element={<Protected><ResumeTemplates /></Protected>} />
      <Route path="/create-cv-legacy" element={<Protected><CreateCV /></Protected>} />
      <Route path="/cover-letter" element={<Protected><PremiumGate feature="Cover Letter"><CoverLetter /></PremiumGate></Protected>} />
      <Route path="/interview" element={<Protected><PremiumGate feature="Interview Practice"><InterviewPractice /></PremiumGate></Protected>} />
      <Route path="/tracker" element={<Protected><PremiumGate feature="Application Tracker"><ApplicationTracker /></PremiumGate></Protected>} />
      <Route path="/career-profile" element={<Protected><CareerProfile /></Protected>} />
      <Route path="/job-agent" element={<Protected><PremiumGate feature="Job Agent"><JobAgent /></PremiumGate></Protected>} />
      <Route path="/pipeline" element={<Protected><PremiumGate feature="Job Pipeline"><Pipeline /></PremiumGate></Protected>} />
      <Route path="/pricing" element={<Protected><Pricing /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="/tutorial" element={<Protected><Tutorial /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <AppRouter />
        <InstallBanner />
      </BrowserRouter>
    </AuthProvider>
  );
}
